import React, { useEffect } from 'react'
import { useRouteError, Link } from 'react-router-dom'
import { AlertTriangle, RefreshCw, Home } from 'lucide-react'

export const ErrorBoundary: React.FC = () => {
  const error = useRouteError() as any
  const errorMessage = error?.message || error?.toString() || ''

  const isChunkError = 
    errorMessage.includes('Failed to fetch dynamically imported module') ||
    errorMessage.includes('error loading dynamically imported module') ||
    errorMessage.includes('imported module')

  useEffect(() => {
    if (isChunkError) {
      // Auto reload on chunk load failure
      console.warn('Chunk load error detected, reloading page...', error)
      window.location.reload()
    }
  }, [isChunkError, error])

  if (isChunkError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50 text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0068FF] mb-4" />
        <p className="text-xs text-gray-500 font-semibold">Đang cập nhật phiên bản mới, vui lòng đợi trong giây lát...</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-100 text-center">
      <div className="bg-white border border-red-100 rounded-3xl p-8 max-w-md w-full shadow-lg space-y-6">
        <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto text-red-600">
          <AlertTriangle className="w-7 h-7" />
        </div>
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-2">Đã có lỗi xảy ra</h2>
          <p className="text-xs text-gray-500 leading-relaxed">
            Hệ thống đã gặp sự cố không mong muốn khi tải trang này.
          </p>
          {errorMessage && (
            <pre className="mt-3 p-3 bg-gray-50 border border-gray-100 rounded-xl text-[10px] text-red-600 font-mono overflow-x-auto text-left whitespace-pre-wrap max-h-32">
              {errorMessage}
            </pre>
          )}
        </div>
        <div className="flex flex-col sm:flex-row gap-2.5">
          <button
            onClick={() => window.location.reload()}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-xs font-bold text-gray-700 bg-white hover:bg-gray-50 border border-gray-300 transition-colors rounded-xl shadow-sm cursor-pointer"
          >
            <RefreshCw className="w-4 h-4" /> Tải lại trang
          </button>
          <Link
            to="/"
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-xs font-bold text-white bg-[#0068FF] hover:bg-[#0052cc] transition-colors rounded-xl shadow-sm cursor-pointer"
          >
            <Home className="w-4 h-4" /> Về trang chủ
          </Link>
        </div>
      </div>
    </div>
  )
}
